import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* createGroup({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.create, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createGroupFailed,
      handledErrors,
      endpoint: api.modifiers.regularusers.create.url
    });
  }
}

export const createGroupSaga = takeEvery(types.CREATE_GROUP_REQUEST, createGroup);